import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DemoTopBar() {
  const [isHidden, setIsHidden] = useState(false);
  const lastScrollYRef = useRef(0);
  const tickingRef = useRef(false);

  useEffect(() => {
    const hideThreshold = 96;
    const showThreshold = 36;
    const minDelta = 2;

    lastScrollYRef.current = window.scrollY;

    const updateHeader = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollYRef.current;

      if (currentScrollY <= showThreshold) {
        setIsHidden(false);
      } else if (delta < -minDelta) {
        setIsHidden(false);
      } else if (currentScrollY >= hideThreshold && delta > 0) {
        setIsHidden(true);
      }

      lastScrollYRef.current = currentScrollY;
      tickingRef.current = false;
    };

    const handleScroll = () => {
      if (!tickingRef.current) {
        window.requestAnimationFrame(updateHeader);
        tickingRef.current = true;
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 py-4 bg-white border-b border-slate-200 transform-gpu transition-transform duration-500 ease-out ${
          isHidden ? "-translate-y-full" : "translate-y-0"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center"
            data-testid="demo-top-logo"
          >
            <img
              src={`${process.env.PUBLIC_URL}/Logo.png`}
              alt="Web & Studio Logo"
              className="h-[80px] md:h-[88px] lg:h-[96px] w-auto object-contain"
            />
          </Link>

          <Link to="/#trabalhos">
            <Button
              variant="outline"
              className="mt-1 rounded-full px-6 border-slate-300 bg-white text-slate-700 hover:bg-slate-100"
              data-testid="demo-back-to-work"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Voltar aos Trabalhos
            </Button>
          </Link>
        </div>
      </nav>
      <div className="h-[112px] md:h-[120px] lg:h-[128px]" />
    </>
  );
}
